import { userHasFeature } from 'refactor/hooks/useUserHasFeature'

export const SIMPLE_UPVALUE_MODAL_FEATURE = 'simple_upvalue_modal'

export function simpleUpvalueModalEnabled(): boolean {
    return userHasFeature(SIMPLE_UPVALUE_MODAL_FEATURE)
}

export function simpleUpvalueModalEnabledForSource(source?: string): boolean {
    return source !== 'ordinal_stream' && simpleUpvalueModalEnabled()
}
